module.exports = __webpack_public_path__ + "img/finland-skin-connective-and-musculoskeletal-diseases-male.feb8c96c.png";